import type { ReactNode } from 'react';

export interface Column<T> {
  header: string;
  cell: (row: T) => ReactNode;
  width?: string;
}

interface Props<T> {
  rows: T[];
  columns: Column<T>[];
  empty_message?: string;
  on_row_click?: (row: T) => void;
}

export default function DataTable<T>({ rows, columns, empty_message, on_row_click }: Props<T>) {
  if (rows.length === 0) {
    return (
      <p className="muted" style={{ padding: 24, margin: 0 }}>
        {empty_message ?? 'No items.'}
      </p>
    );
  }
  return (
    // Scroll a too-wide table WITHIN its container instead of widening the whole page
    // (a wide table — e.g. Usage — otherwise pushes the body past the viewport, giving
    // the page a phantom horizontal scrollbar).
    <div style={{ overflowX: 'auto' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr style={{ borderBottom: '1px solid var(--line)' }}>
          {columns.map((c, i) => (
            <th
              key={i}
              style={{
                textAlign: 'left',
                padding: '12px 16px',
                fontWeight: 600,
                fontSize: 12,
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
                color: 'var(--muted)',
                width: c.width,
              }}
            >
              {c.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr
            key={i}
            onClick={on_row_click ? () => on_row_click(row) : undefined}
            style={{
              borderBottom: '1px solid var(--line)',
              cursor: on_row_click ? 'pointer' : undefined,
            }}
          >
            {columns.map((c, j) => (
              <td key={j} style={{ padding: '12px 16px', fontSize: 14 }}>
                {c.cell(row)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
    </div>
  );
}
